<div id="propertyInfoPanel" class="featurePanel property"
  [class.expanded]="(propertyInfo)">
  @if (selectedProperty !== '') {
    <button class="btn btn-link btn-multi"
      (click)="backToMultiple(propertyInfo[0].properties[0].dbLink)">
      <i class="far fa-chevron-left"></i>
      <h2 class="carouselTitle">Property Information</h2>
    </button>
  }
  @if (selectedProperty === '') {
    <button (click)="closeRightPanel()" class="float-right btn-close my-1 d-block"
      title="Close">
      <h2 class="carouselTitle">Property Information</h2>
      <i class="far fa-chevron-right"></i>
    </button>
  }
  <div class="details-scroll" [style.height.px]="scrollHeight" #propertyDetails>
    <ul class="nav nav-tabs" id="featureTabs" role="tablist">
      <li class="nav-item list-margin">
        <a class="nav-link active" id="general-tab" data-bs-toggle="tab" href="#general" role="tab" aria-controls="general"
        aria-selected="true" title="General">General</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" id="cases-tab" data-bs-toggle="tab" href="#cases" role="tab" aria-controls="cases"
        aria-selected="true" title="Cases">Cases ({{countRecords()}})</a>
      </li>
    </ul>
    <div class="tab-content">
      <div class="tab-pane fade show active pt-2" id="general" role="tabpanel" aria-labelledby="general-tab">
        @if (propertyInfo[0].properties[0].addresses.length > 0) {
          <div class="address-title">
          {{propertyInfo[0].properties[0].addresses[0].fullAddress}}</div>
        }
        <div class="address-photo" id="streetview">
          <a href="http://maps.google.com/maps?q=&layer=c&cbll={{propertyInfo[0].properties[0].details.geography.streetViewLat}},{{propertyInfo[0].properties[0].details.geography.streetViewLong}}&cbp=11,{{propertyInfo[0].properties[0].details.geography.streetViewAngle}},0,0,0"
            target="_blank" class="link" title="Click for Google Street View">
            <img [src]="streetViewStatic"></a>
          </div>
          <div class="panels" id="panels">

            <div class="form-group" [formGroup]="searchPropertyInformationForm" class="searchPI">
              <input type="text" class="form-control searchPropertyInformation" id="searchPropertyInformation"
                placeholder="Search Property Information" formControlName="searchPropertyInformation"
                (keyup)="keyUp.next($event)">
                @if (this.searchPropertyInformationForm.get('searchPropertyInformation').value && this.searchPropertyInformationForm.get('searchPropertyInformation').value.length > 0) {
                  <button type="button"
                    class="clear-search float-right" (click)="onClearPropSearch()">
                    <i class="far fa-times-circle clear-search-icon"></i>
                  </button>
                }
              </div>

              @for (pi of filteredPropertyInfo; track pi) {
                <div class="panel">
                  <button class="btn btn-link" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#' + pi.key"
                    aria-expanded="true" [attr.aria-controls]="pi.key">
                    <h4 class="float-left">{{pi.values[0].value}}</h4>
                    <i class="far fa-chevron-down float-right fa-xs"></i>
                    <i class="far fa-chevron-up float-right  fa-xs"></i>
                  </button>
                  <div id="{{pi.key}}" class="collapse show">
                    @for (child of pi.children; track child) {
                      <div class="key-pair">
                        @if (pi.key !== 'EnergovKey') {
                          <span class="label">{{child.key}}</span>
                        }
                        @if (pi.key === 'EnergovKey') {
                          <h4>{{child.key}}</h4>
                        }
                        @for (value of child.values; track value) {
                          <span>
                            @if ('string' === value.type) {
                              <span [innerHTML]="value.value"></span>
                            }
                            @if ('link' === value.type) {
                              <span><a href="{{value.url}}" target="_blank" class="link"
                              rel="nofollow noopener">{{value.value}}</a>
                              @if (value.small) {
                                <span class="small">{{value.small}}</span>
                                }@if (value.small) {
                                <br />
                              }
                            </span>
                          }
                          @if ('button' === value.type) {
                            <button (click)="openDrawing(value.drawingNumber, value.drawingType)"
                            class="no-select btn btn-link text-start">{{value.value}}</button>
                          }
                        </span>
                      }
                      <!-- energov section
                      <div *ngIf="child.children">
                        <div class="key-pair" *ngFor="let c of child.children">
                          <button class="btn btn-link collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#' + c.key"
                            aria-expanded="true" [attr.aria-controls]="c.key">
                            <span class="float-left eg-child">{{c.key}}</span>
                            <i class="far fa-chevron-down float-right fa-xs"></i>
                            <i class="far fa-chevron-up float-right  fa-xs"></i>
                          </button>
                          <div  class="collapse" id="{{c.key}}">
                            <span *ngFor="let val of c.children">
                              <span class="label">{{val.key}}</span>
                              <span [class.status-hold]="val.key === 'Status' && val.values[0].value === 'Hold'">
                                <span *ngIf="'string' === val.values[0].type" [innerHTML]="val.values[0].value"></span><span *ngIf="val.key === 'Status' && val.values[0].value === 'Hold'" class="hold ml-1"><i class="fas fa-flag"></i></span>
                              </span>
                              <span *ngIf="'link' === val.values[0].type"><a href="{{val.values[0].url}}" target="_blank" class="link"
                              rel="nofollow noopener">{{val.values[0].value}}</a>
                              <span class="small" *ngIf="val.values[0].small">{{val.values[0].small}}</span><br *ngIf="val.values[0].small" />
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>-->
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>

      <!-- energov-->
      <div class="tab-pane fade pt-2" id="cases" role="tabpanel" aria-labelledby="cases-tab">
        <p class="disclaim">EnerGov linked data shown in property information is for current state parcels and addresses
        only. For a full historic view of cases at a location, please add the EnerGov layers to the map. </p>
        <p class="disclaim">Cases will link to the main parcel identified in EnerGov.</p>
        <p class="disclaim">Voided permits have been filtered out.</p>
        @if (energovInfo) {
          <div class="panels">
            @for (cases of fullCasesInfo; track cases) {
              <div class="panel">
                <button class="btn btn-link" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#' + cases.key"
                  aria-expanded="true" [attr.aria-controls]="'#' + cases.key">
                  <h4 class="float-left">{{cases.values[0].value}}</h4>
                  <i class="far fa-chevron-down float-right fa-xs"></i>
                  <i class="far fa-chevron-up float-right  fa-xs"></i>
                </button>
                <div id="{{cases.key}}" class="collapse show">
                  @if (cases.children.length === 0) {
                    <div class="no-cases">No associated {{cases.values[0].value}} found
                    </div>
                  }
                  @for (child of cases.children; track child) {
                    <div class="key-pair">
                      <button class="btn btn-link collapsed" type="button" data-bs-toggle="collapse"
                        [attr.data-bs-target]="'#' + getTabKey(child.key)" aria-expanded="true"
                        [attr.aria-controls]="'#' + getTabKey(child.key)">
                        <span class="float-left title-number">{{child.key}}</span>
                        <i class="far fa-chevron-down float-right fa-xs"></i>
                        <i class="far fa-chevron-up float-right  fa-xs"></i>
                      </button>
                      <div id="{{getTabKey(child.key)}}" class="collapse">
                        @for (c of child.children; track c) {
                          <span>
                            <span class="label">{{c.key}}</span>
                            @if ('string' === c.values[0].type) {
                              <span
                              [innerHTML]="c.values[0].value ? c.values[0].value : '-'"></span>
                            }
                            @if ('link' === c.values[0].type) {
                              <span><a href="{{c.values[0].url}}" target="_blank" class="link"
                              rel="nofollow noopener">{{c.values[0].value}}</a>
                              @if (c.values[0].small) {
                                <span class="small">{{c.values[0].small}}</span>
                                }@if (c.values[0].small) {
                                <br
                                  />
                              }
                            </span>
                          }
                        </span>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          <!-- Request to not show Planning Cases in property viewer. Instead to show static text. -->
          <div class="panel">
            <button class="btn btn-link" type="button" data-bs-toggle="collapse" data-bs-target="#PlanningCasesKey"
              aria-expanded="true" aria-controls="#PlanningCasesKey">
              <h4 class="float-left">Planning Cases</h4>
              <i class="far fa-chevron-down float-right fa-xs"></i>
              <i class="far fa-chevron-up float-right  fa-xs"></i>
            </button>
            <div id="PlanningCasesKey" class="collapse show">
              <div class="no-cases">Due to nature of planning cases and multiple properties, please see the 'EnerGov
              Plans' layer for the full historic view.</div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>